// Usage: new HicomDropDownList('dropDownId');
// Accessibility fixes for the drop down list.
class HicomDropDownList {
    private dropDownId: string;

    constructor(id: string) {
        this.dropDownId = id;
        this.init();
    }

    private init(): void {
        this.accessibilityInit();
    }

    /**
     * Initializes accessibility features for the dropdown list.
     * Sets the aria-label attribute for the listbox to improve screen reader support.
     */
    private accessibilityInit(): void {
        const listbox: Element | null = document.querySelector(`input[aria-controls="${this.dropDownId}_listbox"]`);
        if (listbox) {
            listbox.setAttribute('aria-label', 'Search within the dropdown options');
        }
    }
}